/** biome-ignore-all lint/correctness/noNestedComponentDefinitions: TODO: fix */
/** biome-ignore-all lint/style/noMagicNumbers: TODO: fix */
/** biome-ignore-all lint/correctness/useUniqueElementIds: TODO: fix */
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Checkbox, Col, Row } from 'antd';

import FormInput from '@/views/components/Inputs/FormInput';
import FormSelectBox from '@/views/components/Inputs/FormSelectBox';
import { mergeByKeys } from '@/views/screens/Savers/utils/utils';

import { APP_ROUTES } from '../../../contants/routes';
import { setAppLoader } from '../../../redux/common/CommonActions';
import { getAllSaversCarriers, saveShipmentData, saveTrailerMovement } from '../../../redux/Savers/SaversEffects';
import AlertModal from '../../components/Modals/AlertModal';

export default function TrailerTransferModal(props) {
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertOpen1, setAlertOpen1] = useState(false);
  const [alertMessage1, setAlertMessage1] = useState('');
  const [carrierOptions, setCarrierOptions] = useState([]);
  const [carrierName, setCarrierName] = useState(0);
  const [legName, setLegName] = useState(0);
  const [pickupShippingCost, setPickupShippingCost] = useState(0);
  const [deliveryShippingCost, setDeliveryShippingCost] = useState(0);
  const [isMultiCarrier, setIsMultiCarrier] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleAlertClose1 = async () => {
    setAlertOpen1(false);
    navigate(APP_ROUTES.SAVERS);
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const SuccessTrailer = async (shipmentData) => {
    if (props.isMultipleUserDetails) {
      props.movementdata[0].trailerMovement.movementType = 'Outbound';
      props.movementdata[1].trailerMovement.movementType = 'Inbound';
      if (isMultiCarrier) {
        props.movementdata[0].trailerMovement.shipmentKey = shipmentData[0].shipmentKey;
        props.movementdata[1].trailerMovement.shipmentKey = shipmentData[1].shipmentKey;
      } else {
        props.movementdata[0].trailerMovement.shipmentKey = shipmentData[0].shipmentKey;
        props.movementdata[1].trailerMovement.shipmentKey = shipmentData[0].shipmentKey;
      }
    } else {
      props.movementdata[0].trailerMovement.shipmentKey = shipmentData[0].shipmentKey;
      if (props.nonMultiLabel.includes('Pickup')) {
        props.movementdata[0].trailerMovement.movementType = 'Outbound';
      } else {
        props.movementdata[0].trailerMovement.movementType = 'Inbound';
      }
    }
    try {
      dispatch(setAppLoader(true));
      const { data } = await saveTrailerMovement(props.movementdata);
      const multipleShipment =
        props.isMultipleUserDetails && isMultiCarrier
          ? `${shipmentData[0].shipmentNo}, ${shipmentData[1].shipmentNo}`
          : shipmentData[0].shipmentNo;
      if (data) {
        setAlertMessage1(`Shipment created. ShipmentNumber: ${multipleShipment}`);
        setAlertOpen1(true);
      } else {
        setAlertMessage('Trailer movement creation error');
        setAlertOpen1(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setAppLoader(false));
    }
  };

  const saveShipment = async () => {
    try {
      if (carrierName === '' || !carrierName) {
        setAlertMessage(`${isMultiCarrier ? 'Pickup Carrier' : 'Carrier'} is Required`);
        setAlertOpen(true);
        return;
      }
      if ((legName === '' || !legName) && props.isMultipleUserDetails && isMultiCarrier) {
        setAlertMessage('Delivery Carrier  is required');
        setAlertOpen(true);
        return;
      }
      dispatch(setAppLoader(true));
      if (!props.isMultipleUserDetails) {
        props.shipmentdata[0].shipmentInformationRequest.carrierKey = carrierName;
        props.shipmentdata[0].shipmentInformationRequest.rateShopCost = pickupShippingCost;
      } else if (isMultiCarrier) {
        props.shipmentdata[0].shipmentInformationRequest.carrierKey = carrierName;
        props.shipmentdata[1].shipmentInformationRequest.carrierKey = legName;
        props.shipmentdata[0].shipmentInformationRequest.rateShopCost = pickupShippingCost;
        props.shipmentdata[1].shipmentInformationRequest.rateShopCost = deliveryShippingCost;
      } else {
        props.shipmentdata[0].shipmentInformationRequest.carrierKey = carrierName;
        props.shipmentdata[0].shipmentInformationRequest.rateShopCost = pickupShippingCost;
      }
      const finalShipment = [];
      if (!isMultiCarrier && props.isMultipleUserDetails) {
        const currentShipments = props.shipmentdata;
        finalShipment.push(
          ...mergeByKeys(currentShipments, ['shipmentOriginInformation', 'shipmentDestinationInformation']),
        );
      }

      const shipmentData = !isMultiCarrier && props.isMultipleUserDetails ? finalShipment : props.shipmentdata;
      const origins = shipmentData[0].shipmentOriginInformation || [];
      const destinations = shipmentData[0].shipmentDestinationInformation || [];

      origins.forEach((origin, index) => {
        const seq = 1 + index * 2;
        origin.sequence = seq;
        origin.displaySequence = seq;

        if (origin.shipmentOriginAdditionalInformation) {
          origin.shipmentOriginAdditionalInformation.sequence = seq;
          origin.shipmentOriginAdditionalInformation.displaySequence = seq;
        }
      });

      destinations.forEach((destination, index) => {
        const seq = 2 + index * 2;
        destination.sequence = seq;
        destination.displaySequence = seq;

        if (destination.shipmentDestinationAdditionalInformation) {
          destination.shipmentDestinationAdditionalInformation.sequence = seq;
          destination.shipmentDestinationAdditionalInformation.displaySequence = seq;
        }
      });

      const { data } = await saveShipmentData(shipmentData);

      if (data) {
        await SuccessTrailer(data);
      } else {
        setAlertMessage('Shipment creation error');
        setAlertOpen(true);
      }
    } catch (error) {
      console.error(error);
      setAlertMessage('Shipment creation error');
      setAlertOpen(true);
    } finally {
      dispatch(setAppLoader(false));
    }
  };

  const getSaversCarriers = async () => {
    dispatch(setAppLoader(true));
    try {
      const { data } = await getAllSaversCarriers();
      const options = data?.map((row) => ({
        label: row.carrierName,
        value: row.carrierKey,
      }));
      setCarrierOptions(options);
    } catch (error) {
      console.log('error', error);
      setCarrierOptions([]);
    } finally {
      dispatch(setAppLoader(false));
    }
  };

  const setCarrierNameValue = (e) => {
    if (e) {
      setCarrierName(e.value);
    }
  };
  const setLegNameValue = (e) => {
    if (e) {
      setLegName(e.value);
    }
  };

  const handleShippingCost = (e, name) => {
    if (name === 'pickup') {
      setPickupShippingCost(e.currentTarget.value);
    } else {
      setDeliveryShippingCost(e.currentTarget.value);
    }
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: Todo: add dependencies
  useEffect(() => {
    getSaversCarriers();
  }, []);

  const handleAlertOk = () => {
    setAlertOpen(false);
  };

  const toggleMultiCarrier = () => {
    setIsMultiCarrier(!isMultiCarrier);
  };

  return (
    <div className="popup-body p-5">
      <AlertModal
        title="Alert"
        open={alertOpen1}
        description={alertMessage1}
        onOk={handleAlertClose1}
        onClose={handleAlertClose1}
      />
      <AlertModal
        title="Alert"
        open={alertOpen}
        description={alertMessage}
        onOk={handleAlertOk}
        onClose={handleAlertClose}
      />
      <div className="py-10 pl-10">
        <span className="mr-20">Please Select a Carrier:</span>
        {props.isMultipleUserDetails && (
          <span className="flex items-center gap-2 cursor-pointer">
            <Checkbox
              name="multiCarrier"
              id="multiCarrier"
              className="mb-15"
              onChange={toggleMultiCarrier}
              value={isMultiCarrier}
            />
            <label className="f-120 ml-8 cursor-pointer" htmlFor="multiCarrier">
              Multiple Carrier?
            </label>
          </span>
        )}
      </div>
      <Row gutter={[16, 16]} className="trailer-transfer-form  pl-[20px] d-flex  flex-direction-column pl-10  pt-10">
        <div className="d-flex gap-2">
          <Col xs={11} className="d-flex w-full gap-2">
            <FormSelectBox
              label={isMultiCarrier ? 'Pickup Carrier' : 'Carrier'}
              editMode
              id="selCarrier"
              name="Carrier"
              margin="m-0"
              singleLineMode
              options={carrierOptions}
              placeholder="Select Carrier"
              onChange={setCarrierNameValue}
              value={carrierName}
              rules={[
                {
                  message: `${isMultiCarrier ? 'Please  select pickup carrier' : 'Please select carrier'}`,
                  required: true,
                },
              ]}
            />
          </Col>
          <Col xs={11} className="d-flex w-full gap-2">
            {props.isMultipleUserDetails && isMultiCarrier && (
              <FormSelectBox
                label="Delivery Carrier"
                editMode
                id="selCarrier"
                name="leg2"
                margin="m-0"
                singleLineMode
                options={carrierOptions}
                placeholder="Select Carrier"
                onChange={setLegNameValue}
                value={legName}
                rules={[
                  {
                    message: 'Please select delivery carrier',
                    required: true,
                  },
                ]}
              />
            )}
          </Col>
        </div>
        <div className="d-flex gap-2">
          <Col xs={11} className="d-flex w-full gap-2">
            <FormInput
              label={isMultiCarrier ? 'Pickup Shipping Cost' : 'Shipping Cost'}
              editMode
              margin="m-0"
              singleLineMode
              placeholder="Shipping Cost"
              onChange={(e) => handleShippingCost(e, 'pickup')}
              defaultValue={pickupShippingCost}
              name="pickupShippingCost"
            />
          </Col>
          <Col xs={11} className="d-flex w-full gap-2">
            {props.isMultipleUserDetails && isMultiCarrier && (
              <FormInput
                label="Delivery Shipping Cost"
                editMode
                margin="m-0"
                singleLineMode
                placeholder="Shipping Cost"
                onChange={(e) => handleShippingCost(e, 'delivery')}
                defaultValue={deliveryShippingCost}
                name="deliveryShippingCost"
              />
            )}
          </Col>
        </div>
        <Col xs={24}>
          <div className="pl-10 py-10 d-flex gap-2">
            <button
              type="button"
              className="btn btn-dipblue cursor-pointer"
              style={{
                borderRadius: '4px',
                minWidth: '120px',
                padding: '8px 16px',
              }}
              onClick={saveShipment}
            >
              Generate
            </button>
            <button
              type="button"
              className="btn btn-dipblue cursor-pointer"
              style={{
                borderRadius: '4px',
                minWidth: '120px',
                padding: '8px 16px',
              }}
              onClick={() => props.handler()}
            >
              Back
            </button>
          </div>
        </Col>
      </Row>
    </div>
  );
}
